import React from 'react';
import { MenuStatus } from './ui/MenuStatus';
export const manageMenuColumns = [
    {
        key: "name_public", label: 'manageMenu.columns.name'
    },
    {
        key: "description", label: 'manageMenu.columns.description',
    },
    {
        key: "enabled", label: '',
        componentTransform: (enabled: any, key: any) => {
            return <MenuStatus enabled={enabled} key={key} />;
        },
    },
];



